import { Block } from './Block'

/**
 * Works with the core/list WordPress block.
 */
export class CoreList extends Block {
    constructor(block) {
        super(block)
    }

    setHTML(block) {
        return block?.saveContent ? block.saveContent : ''
    }
}
